import { FC } from "react";
import PermissionTable from "@/components/permissions/permissionTable";
import RestrictedPage from "@/consumer/restrictedPage";

const PermissionList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_permission">
      <PermissionTable />
    </RestrictedPage>
  );
};

export default PermissionList;
